import script from "./UserToroku.vue?vue&type=script&setup=true&lang=js"
export * from "./UserToroku.vue?vue&type=script&setup=true&lang=js"

import "./UserToroku.vue?vue&type=style&index=0&id=c27c491e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-c27c491e"]])

export default __exports__